export type MockRecordRow = {
  key: string;
  fullName: string;
  actDate: string;
  workName: string;
  workType: string;
  approvalStatus: string;
  notes: string;
  closing: string;
  creatorName: string;
  assigneeNames: string;
  inspectorNames: string;
  sectionName: string;
  currentWork: string;
  contract: string;
  ks2: string;
};

export const MOCK_RECORDS: MockRecordRow[] = [
  {
    key: "1",
    fullName: "Акт выполненных работ (ФСК) №2",
    actDate: "27.12.2025",
    workName: "Устройство слоя из плодородного грунта под основание газона",
    workType: "Общестроительные работы",
    approvalStatus: "NEW",
    notes: "-",
    closing: "Закрытие от 1 нояб. 2023 г. за период: 30 апр. 2023 г. - 30 июн. 2023 г.",
    creatorName: "Гронская Екатерина Ивановна",
    assigneeNames: "Черных Павел Владимирович\nФатьянов Александр Иванович",
    inspectorNames: "Черных Павел Владимирович\nФатьянов Александр Иванович",
    sectionName: "Доп. работы",
    currentWork: "Разработка грунта",
    contract: "ПИК / ДРСУ-1",
    ks2: "КС-22",
  },
  {
    key: "2",
    fullName: "АОСР №23",
    actDate: "15.11.2025",
    workName: "Монтаж кровельного покрытия",
    workType: "Кровельные работы",
    approvalStatus: "UPDATED",
    notes: "-",
    closing: "Закрытие от 10 окт. 2025 г. за период: 01 сен. 2025 г. - 31 окт. 2025 г.",
    creatorName: "Иванов Иван Иванович",
    assigneeNames: "Петров Пётр Сергеевич",
    inspectorNames: "Сидоров Сидор Сидорович",
    sectionName: "Кровля",
    currentWork: "Кровля",
    contract: "ДРСУ-2",
    ks2: "КС-15",
  },
  {
    key: "3",
    fullName: "Акт скрытых работ №1",
    actDate: "03.10.2025",
    workName: "Арматурные работы фундамента",
    workType: "Фундамент",
    approvalStatus: "APPROVING",
    notes: "-",
    closing: "-",
    creatorName: "Козлов Андрей Викторович",
    assigneeNames: "Новиков Дмитрий\nСмирнова Анна",
    inspectorNames: "Козлов Андрей Викторович",
    sectionName: "Нулевой цикл",
    currentWork: "Арматура",
    contract: "ПИК / ДРСУ-1",
    ks2: "-",
  },
  {
    key: "4",
    fullName: "Акт выполненных работ №5-этаж 2",
    actDate: "20.09.2025",
    workName: "Штукатурные работы внутренних стен",
    workType: "Отделочные работы",
    approvalStatus: "APPROVED",
    notes: "-",
    closing: "Закрытие от 15 авг. 2025 г. за период: 01 июл. 2025 г. - 31 авг. 2025 г.",
    creatorName: "Морозова Елена",
    assigneeNames: "Волков Олег\nКузнецова Мария",
    inspectorNames: "Волков Олег",
    sectionName: "Этаж 2",
    currentWork: "Штукатурка",
    contract: "ПИК / ДРСУ-1",
    ks2: "КС-8",
  },
  {
    key: "5",
    fullName: "Акт на электромонтаж №12",
    actDate: "01.12.2025",
    workName: "Прокладка кабельных трасс",
    workType: "Электромонтаж",
    approvalStatus: "SIGNING",
    notes: "-",
    closing: "-",
    creatorName: "Соколов Геннадий",
    assigneeNames: "Лебедев Игорь\nФедоров Николай\nОрлова Татьяна",
    inspectorNames: "Соколов Геннадий\nЛебедев Игорь",
    sectionName: "ЭОМ",
    currentWork: "Электропроводка",
    contract: "Субподряд Энерго",
    ks2: "КС-31",
  },
  {
    key: "6",
    fullName: "Акт выполненных работ (ФСК) №3",
    actDate: "28.11.2025",
    workName: "Устройство стяжки пола",
    workType: "Общестроительные работы",
    approvalStatus: "SIGNED",
    notes: "-",
    closing: "Закрытие от 20 нояб. 2025 г. за период: 01 окт. 2025 г. - 30 нояб. 2025 г.",
    creatorName: "Гронская Екатерина Ивановна",
    assigneeNames: "Черных Павел Владимирович",
    inspectorNames: "Фатьянов Александр Иванович",
    sectionName: "Доп. работы",
    currentWork: "Стяжка",
    contract: "ПИК / ДРСУ-1",
    ks2: "КС-22",
  },
  {
    key: "7",
    fullName: "Акт скрытых работ по ОВ и ВК",
    actDate: "14.10.2025",
    workName: "Разводка труб отопления",
    workType: "ОВ и ВК",
    approvalStatus: "REJECTED",
    notes: "-",
    closing: "-",
    creatorName: "Павлов Сергей",
    assigneeNames: "Семёнов Алексей\nЕгорова Ольга",
    inspectorNames: "Павлов Сергей",
    sectionName: "Инженерия",
    currentWork: "Отопление",
    contract: "ТеплоМонтаж",
    ks2: "-",
  },
  {
    key: "8",
    fullName: "АОСР №24",
    actDate: "05.11.2025",
    workName: "Монтаж оконных блоков",
    workType: "Отделочные работы",
    approvalStatus: "APPROVING",
    notes: "-",
    closing: "Закрытие от 1 нояб. 2025 г. за период: 01 окт. 2025 г. - 31 окт. 2025 г.",
    creatorName: "Иванов Иван Иванович",
    assigneeNames: "Петров Пётр Сергеевич\nМихайлов Михаил",
    inspectorNames: "Петров Пётр Сергеевич",
    sectionName: "Фасад",
    currentWork: "Окна",
    contract: "ДРСУ-2",
    ks2: "КС-18",
  },
  {
    key: "9",
    fullName: "Акт на земляные работы",
    actDate: "22.08.2025",
    workName: "Разработка котлована",
    workType: "Земляные работы",
    approvalStatus: "APPROVED",
    notes: "-",
    closing: "Закрытие от 15 авг. 2025 г. за период: 01 июл. 2025 г. - 15 авг. 2025 г.",
    creatorName: "Козлов Андрей Викторович",
    assigneeNames: "Новиков Дмитрий",
    inspectorNames: "Козлов Андрей Викторович",
    sectionName: "Нулевой цикл",
    currentWork: "Котлован",
    contract: "ПИК / ДРСУ-1",
    ks2: "КС-1",
  },
  {
    key: "10",
    fullName: "Акт выполненных работ №7",
    actDate: "30.12.2025",
    workName: "Устройство перегородок из ГКЛ",
    workType: "Отделочные работы",
    approvalStatus: "SIGNING",
    notes: "-",
    closing: "-",
    creatorName: "Морозова Елена",
    assigneeNames: "Волков Олег\nКузнецова Мария\nСмирнова Анна",
    inspectorNames: "Волков Олег\nКузнецова Мария",
    sectionName: "Этаж 3",
    currentWork: "Перегородки",
    contract: "ПИК / ДРСУ-1",
    ks2: "КС-11",
  },
  {
    key: "11",
    fullName: "Акт на фасадные работы",
    actDate: "12.11.2025",
    workName: "Утепление фасада",
    workType: "Фасадные работы",
    approvalStatus: "UPDATED",
    notes: "-",
    closing: "Закрытие от 10 нояб. 2025 г. за период: 01 окт. 2025 г. - 10 нояб. 2025 г.",
    creatorName: "Иванов Иван Иванович",
    assigneeNames: "Петров Пётр Сергеевич",
    inspectorNames: "Иванов Иван Иванович",
    sectionName: "Фасад",
    currentWork: "Утепление",
    contract: "ДРСУ-2",
    ks2: "КС-20",
  },
  {
    key: "12",
    fullName: "Акт выполненных работ (ФСК) №4",
    actDate: "18.12.2025",
    workName: "Устройство гидроизоляции",
    workType: "Общестроительные работы",
    approvalStatus: "NEW",
    notes: "-",
    closing: "-",
    creatorName: "Гронская Екатерина Ивановна",
    assigneeNames: "Черных Павел Владимирович\nФатьянов Александр Иванович\nМикляев Дмитрий Степанович",
    inspectorNames: "Щепкин Андрей Андреевич",
    sectionName: "Доп. работы",
    currentWork: "Гидроизоляция",
    contract: "ПИК / ДРСУ-1",
    ks2: "КС-25",
  },
];

/** Мок total для пагинации (больше чем длина MOCK_RECORDS, чтобы была «не одна страница») */
export const MOCK_RECORDS_TOTAL = 255;

/** Мок-опции для фильтров (временно) */
const icon = <span className="registry-filters__mock-icon" />;

export const MOCK_WORK_TYPE_OPTIONS = [
  { id: "ROOF", status: "Кровельные работы", icon },
  { id: "GENERAL", status: "Общестроительные работы", icon },
  { id: "FINISH", status: "Отделочные работы", icon },
  { id: "ELECTRO", status: "Электромонтаж", icon },
  { id: "HVAC", status: "ОВ и ВК", icon },
  { id: "FACADE", status: "Фасадные работы", icon },
  { id: "GROUND", status: "Земляные работы", icon },
];

export const MOCK_ACT_TYPE_OPTIONS = [
  { id: "AVR_FSK", status: "Акт ФСК", icon },
  { id: "AVR", status: "АОСР", icon },
  { id: "HIDDEN", status: "Скрытые работы", icon },
];

export const MOCK_SIGNER_OPTIONS = [
  { id: "1", status: "Черных Павел Владимирович", icon },
  { id: "2", status: "Фатьянов Александр Иванович", icon },
  { id: "3", status: "Гронская Екатерина Ивановна", icon },
  { id: "4", status: "Иванов Иван Иванович", icon },
];

export const MOCK_STATUS_OPTIONS = [
  { id: "NEW", status: "Новое", icon, count: 0 },
  { id: "UPDATED", status: "Обновлено", icon, count: 49 },
  { id: "APPROVING", status: "На согласовании", icon, count: 0 },
  { id: "APPROVED", status: "Согласовано", icon, count: 32 },
  { id: "SIGNING", status: "На подписании", icon, count: 1 },
  { id: "SIGNED", status: "Подписано", icon, count: 472 },
  { id: "REJECTED", status: "Отклонено", icon, count: 1 },
];
